import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import {
    useAccessToken,
    standardErrorHandle,
    IErrorContext,
    isErrorContext,
    RoleType,
} from "modules/common";
import { useHistory } from "react-router-dom";
import { AppRoutes } from "routing";
import { changeNiasEntity, ChangeNiasEntityRequest, checkEpUserRole } from "services";

const defaultErrorMessage = "Pogreška pri promijeni subjekta";
const errorHandler = (
    error: AxiosError<IErrorContext> | unknown,
    history: { push: (path: string) => void }
) => {
    if (axios.isAxiosError(error) && isErrorContext(error)) {
        const [first] = error.response!.data.statuses;
        if (first.code === "Authentication.OK.ChangeEntityRedirectToRegistration") {
            history.push(AppRoutes.SignUp);
            return;
        } else if (first.code === "Authentication.Error.ChangeEntityNotFound") {
            history.push(AppRoutes.Unauthorized);
            return;
        }
    }

    standardErrorHandle(error, defaultErrorMessage);
};
export const useChangeNiasEntity = () => {
    const accessToken = useAccessToken();
    const history = useHistory();

    return useMutation({
        mutationFn: async (request: ChangeNiasEntityRequest) => {
            if (!accessToken) throw Error(defaultErrorMessage);
            const response = await changeNiasEntity(request, accessToken);
            return response.data;
        },
        onError: error => errorHandler(error, history),
    });
};

export const useCheckEpUserRole = () => {
    return useMutation({
        mutationFn: async (epToken: string) => {
            const response = await checkEpUserRole(epToken);
            return response.data as RoleType | undefined;
        },
    });
};
